import { render, staticRenderFns } from "./NetMonitor.vue?vue&type=template&id=fc2b96d4&"
import script from "./NetMonitor.vue?vue&type=script&lang=js&"
export * from "./NetMonitor.vue?vue&type=script&lang=js&"
import style0 from "./NetMonitor.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports